import { useMemo } from 'react';
import { deriveErrorMessage } from '../../util/deriveErrorMessage';
export var useFormError = props => {
  var {
    errors
  } = props;
  var derivedErrorMessage = useMemo(() => deriveErrorMessage(errors), [errors]);
  return {
    errorMessage: derivedErrorMessage
  };
};